// extracted by mini-css-extract-plugin
export default {"shareContainer":"shareButton_shareContainer__pmBT5","copyBtn":"shareButton_copyBtn__Jgbxy","shareBtn":"shareButton_shareBtn__2flqW"};